module.exports = __webpack_public_path__ + "img/zl1.3d79d338.png";